// ==============================|| OVERRIDES - LINK ||============================== //

export default function Link(theme) {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
      styleOverrides: {
        root: {
          // Add a cursor pointer on hover
          '&:hover': {
            cursor: 'pointer',
          },
        },
      },
    },
  };
}
